var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('PlotCard',{attrs:{"data":_vm.plot,"screenProperties":_vm.screenProperties,"type":_vm.type,"width":_vm.type !== 'plot-grid' ? _vm.cardWidth : '100%'},on:{"update-widget":_vm.updateWidget}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6d8f84d5","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/plotGrid/PlotGridCard.vue
// module id = null
// module chunks = 